var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-container flex-align-top flex-direction-row",attrs:{"id":"app"}},[_c('sidebar-wrapper'),_vm._v(" "),_c('toast-wrapper'),_vm._v(" "),_c('modal-manager'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('server-status-badge')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ab30146","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 